import { render, staticRenderFns } from "./xbn_lottery.vue?vue&type=template&id=35e4da96&"
import script from "./xbn_lottery.vue?vue&type=script&lang=js&"
export * from "./xbn_lottery.vue?vue&type=script&lang=js&"
import style0 from "./xbn_lottery.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports